import { Device, until } from '@helpers/media';
import SvgSearchIcon from '@img/icons/search.svg';
import * as React from 'react';
import useClickAway from 'react-use/lib/useClickAway';
import Button from '../Buttons/Button/Button';
import SearchTypeahead from '../SearchTypeahead/SearchTypeahead';
import S from './Search.styles';
const Search = ({ label, placeholder, buttonText, visible, usedInBanner, resultsPageUrl, onSubmit, }) => {
    const searchRef = React.useRef(null);
    const inputRef = React.useRef(null);
    const [searchTerm, setSearchTerm] = React.useState('');
    const [isFocused, setIsFocused] = React.useState(false);
    useClickAway(searchRef, () => resetSearch());
    React.useEffect(() => {
        const isMobile = window.matchMedia(`${until(Device.TabletLarge)}`).matches;
        if (!isMobile || !inputRef.current) {
            return;
        }
        if (!visible) {
            resetSearch();
        }
    }, [visible]);
    return (React.createElement(React.Fragment, null,
        usedInBanner && React.createElement(S.Label, { htmlFor: "search-banner" }, label),
        React.createElement(S.Container, { ref: searchRef, "data-search-banner": usedInBanner },
            React.createElement(S.Input, { ...(usedInBanner ? { id: 'search-banner' } : {}), ref: inputRef, type: "search", placeholder: placeholder, "aria-label": label, onFocus: () => setIsFocused(true), onChange: (event) => setSearchTerm(event.currentTarget.value), onKeyDown: (event) => {
                    if (event.key === 'Enter') {
                        if (onSubmit) {
                            event.preventDefault();
                            onSubmit(searchTerm);
                            return;
                        }
                        handleSearchSubmit(resultsPageUrl);
                    }
                } }),
            React.createElement(S.ButtonWrapper, null,
                React.createElement(Button, { iconOnly: true, icon: React.createElement(SvgSearchIcon, null), buttonType: usedInBanner ? 'secondary' : 'primary', type: "submit", onClick: (event) => {
                        if (onSubmit) {
                            event.preventDefault();
                            onSubmit(searchTerm);
                            return;
                        }
                        handleSearchSubmit(resultsPageUrl);
                    } }, buttonText)),
            onSubmit || !isFocused ? null : React.createElement(SearchTypeahead, { query: searchTerm }))));
    /**
     * Resets the search input and state.
     */
    function resetSearch() {
        if (usedInBanner) {
            setIsFocused(false);
            return;
        }
        if (inputRef.current) {
            inputRef.current.value = '';
            setSearchTerm('');
        }
    }
    /**
     * Handles the search submission.
     */
    async function handleSearchSubmit(resultsPageUrl) {
        try {
            window.location.href = `${resultsPageUrl}${searchTerm}`;
        }
        catch (error) {
            console.error('Error submitting search:', error);
        }
    }
};
export default Search;
